import * as React from "react";
import type { SVGProps } from "react";
const SvgDeactivate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#5F6978"
      fillRule="evenodd"
      d="M14.125 8a6.125 6.125 0 1 1-12.25 0 6.125 6.125 0 0 1 12.25 0M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M7.366 4.198c0-.354.28-.634.634-.634s.634.28.634.634V7.38c0 .354-.28.634-.634.634a.63.63 0 0 1-.634-.634zM8 12.185a4.075 4.075 0 0 1-4.067-4.067c0-1.282.59-2.461 1.62-3.242a.645.645 0 0 1 .885.118.645.645 0 0 1-.118.884 2.8 2.8 0 0 0-1.12 2.24 2.814 2.814 0 1 0 5.63 0c0-.884-.413-1.695-1.12-2.24a.62.62 0 0 1-.118-.884.62.62 0 0 1 .884-.118 4.03 4.03 0 0 1 1.62 3.242c-.029 2.24-1.856 4.067-4.096 4.067"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDeactivate;
